/* AURA Core Web Vitals Helper 4.0 */
(() => {
  const vitals = {
    lcp: null,
    cls: 0,
    inp: null,
    fcp: null,
    ttfb: null,
    longTasks: 0,
    resources: []
  };

  const scoreClass = (name, value) => {
    if (value == null) return '';
    if (name === 'LCP') return value <= 2500 ? 'good' : value <= 4000 ? 'warn' : 'bad';
    if (name === 'CLS') return value <= .1 ? 'good' : value <= .25 ? 'warn' : 'bad';
    if (name === 'INP') return value <= 200 ? 'good' : value <= 500 ? 'warn' : 'bad';
    if (name === 'FCP') return value <= 1800 ? 'good' : value <= 3000 ? 'warn' : 'bad';
    if (name === 'TTFB') return value <= 800 ? 'good' : value <= 1800 ? 'warn' : 'bad';
    return 'good';
  };

  const fmt = (name, value) => {
    if (value == null) return '—';
    if (name === 'CLS') return value.toFixed(3);
    return Math.round(value) + 'ms';
  };

  const dispatch = () => {
    window.AuraVitals = vitals;
    window.dispatchEvent(new CustomEvent('aura:vitals:update', { detail: vitals }));
  };

  const observeVitals = () => {
    try {
      const nav = performance.getEntriesByType('navigation')[0];
      if (nav) vitals.ttfb = nav.responseStart;

      const paint = performance.getEntriesByType('paint');
      const fcp = paint.find(p => p.name === 'first-contentful-paint');
      if (fcp) vitals.fcp = fcp.startTime;

      if ('PerformanceObserver' in window) {
        new PerformanceObserver((list) => {
          const entries = list.getEntries();
          const last = entries[entries.length - 1];
          if (last) {
            vitals.lcp = last.startTime;
            dispatch();
          }
        }).observe({ type: 'largest-contentful-paint', buffered: true });

        new PerformanceObserver((list) => {
          for (const entry of list.getEntries()) {
            if (!entry.hadRecentInput) vitals.cls += entry.value || 0;
          }
          dispatch();
        }).observe({ type: 'layout-shift', buffered: true });

        new PerformanceObserver((list) => {
          const entries = list.getEntries();
          entries.forEach(entry => {
            vitals.inp = Math.max(vitals.inp || 0, entry.duration || 0);
          });
          dispatch();
        }).observe({ type: 'event', buffered: true, durationThreshold: 40 });

        new PerformanceObserver((list) => {
          vitals.longTasks += list.getEntries().length;
          dispatch();
        }).observe({ type: 'longtask', buffered: true });

        new PerformanceObserver((list) => {
          vitals.resources = list.getEntries()
            .filter(r => r.transferSize && r.transferSize > 150000)
            .slice(-12)
            .map(r => ({ name: r.name.split('/').pop().slice(0, 42), size: r.transferSize }));
          dispatch();
        }).observe({ type: 'resource', buffered: true });
      }
    } catch (err) {
      console.warn('[AURA] Vitals observer unavailable', err);
    }

    dispatch();
  };

  const optimizeLCP = () => {
    const candidates = [
      document.querySelector('[data-aura-lcp] img'),
      document.querySelector('.shopify-section:first-of-type img'),
      document.querySelector('main img'),
      document.querySelector('img')
    ].filter(Boolean);

    const img = candidates[0];
    if (img) {
      img.setAttribute('fetchpriority', 'high');
      img.setAttribute('loading', 'eager');
      img.dataset.auraPriority = 'high';
    }
  };

  const reduceCLS = () => {
    document.querySelectorAll('img:not([width]), video:not([width])').forEach(media => {
      const parent = media.parentElement;
      if (parent && !parent.style.aspectRatio) {
        parent.setAttribute('data-aura-stable-media', '');
        if (!parent.style.getPropertyValue('--aura-aspect')) parent.style.setProperty('--aura-aspect', '3 / 4');
      }
    });

    document.querySelectorAll('[data-aura-reserve]').forEach(el => {
      el.setAttribute('data-aura-reserve-space', '');
      if (el.dataset.auraReserve) el.style.setProperty('--aura-reserved-height', el.dataset.auraReserve + 'px');
    });
  };

  const panel = () => {
    const enabled = new URLSearchParams(location.search).get('aura_vitals') === '1' || localStorage.getItem('aura_vitals_debug') === 'true';
    if (!enabled) return;
    document.body.setAttribute('data-aura-vitals-debug', 'true');

    const p = document.createElement('div');
    p.className = 'aura-vitals-panel4';
    p.innerHTML = '<h3>AURA Vitals</h3><div class="aura-vitals-panel4__grid" data-vitals-rows></div>';

    const t = document.createElement('button');
    t.className = 'aura-vitals-toggle4';
    t.textContent = 'CWV';

    document.body.appendChild(p);
    document.body.appendChild(t);

    const render = () => {
      const rows = p.querySelector('[data-vitals-rows]');
      const data = [
        ['LCP', vitals.lcp],
        ['CLS', vitals.cls],
        ['INP', vitals.inp],
        ['FCP', vitals.fcp],
        ['TTFB', vitals.ttfb],
        ['Long Tasks', vitals.longTasks]
      ];
      rows.innerHTML = data.map(([name, value]) => {
        const cls = scoreClass(name, value);
        const shown = name === 'Long Tasks' ? value : fmt(name, value);
        return `<div class="aura-vitals-panel4__row"><strong>${name}</strong><span class="aura-vitals-panel4__score aura-vitals-panel4__score--${cls}">${shown}</span></div>`;
      }).join('') + (vitals.resources.length ? `<div class="aura-vitals-panel4__row"><strong>Large resources</strong><span>${vitals.resources.length}</span></div>` : '');
    };

    t.addEventListener('click', () => {
      p.classList.toggle('is-visible');
      render();
    });
    window.addEventListener('aura:vitals:update', render);
  };

  const init = () => {
    document.body?.classList.add('aura-vitals4');
    optimizeLCP();
    reduceCLS();
    observeVitals();
    panel();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('shopify:section:load', () => {
    optimizeLCP();
    reduceCLS();
  });
})();
